<template>
    <div>

        <div v-if="this.value">
            <img src="/images/icon-basket-full.svg" @click="toggle()" class="img-hover"  alt="">
            <div :class="['cartcounter', {'menu_visible': menu_visible}]" v-if="cart.cart"  @click="toggle()" >
                {{ cartdata_counter }}
            </div>
        </div>
        <div v-if="!this.value" >
            <img src="/images/icon-basket.svg" @click="toggle()" class="img-hover"  alt="">
            <div :class="['cartcounter', {'menu_visible': menu_visible}]" v-if="cart.cart"  @click="toggle()" >
                {{ cartdata_counter }}
            </div>
        </div>

    </div>
</template>
<script>

import { EventBus } from '../../eventbus.js';

export default {
    props: ['value', 'cart'],
    data () {
        return {
            menu_visible: this.value
        }
    },
    computed: {
        cartdata_counter(){
            // return 1;

            if (this.cart.cart.data) {
                return this.cart.cart.data.length;
            } else {
                return 0
            }

        }
    },
    methods: {
        close() {

            console.log('click close');
            this.menu_visible = false;
            this.$emit('input', this.menu_visible)
        },
        toggle() {


            this.menu_visible = !this.menu_visible;
            this.$emit('input', this.menu_visible);
            if (this.menu_visible) {
                this.$root.loadCart(true);
            }
        }
    },
    mounted() {
          EventBus.$on('cart-updated', (newCart) => {
            this.cart = newCart;
        });
        // console.log('CartNav Component mounted.');

    }
}
</script>
<style lang="css">
.img-hover {
    cursor: pointer;
}

</style>
